import type { IMappers } from 'shared/repositories/cpd/v1/get-chat-id';
import type { IV1GetChatIdResponse } from 'shared/repositories/cpd/entities/v1_get_chat_id/V1GetChatIdResponse';

import type { IGetChatIdResponseError, IGetChatIdResponseSuccess } from '../types';

export const map200Response = (response: IV1GetChatIdResponse): IGetChatIdResponseSuccess => {
  const { chatId = null } = response;

  return {
    isSuccess: true,
    chatId,
  };
};

export const map400Response = (): IGetChatIdResponseError => {
  return {
    chatId: null,
    isSuccess: false,
  };
};

export const mappers: IMappers<IGetChatIdResponseSuccess, IGetChatIdResponseError> = {
  200: map200Response,
  400: map400Response,
};
